import { CheckCircle2, Circle, Rocket } from "lucide-react";

export default function SmsGoLiveChecklist({ steps = [] }) {
  const done = steps.filter((s) => s.done).length;
  const next = steps.find((s) => !s.done);
  return (
    <section className="border border-brand/40 bg-gradient-to-br from-brand/5 to-[hsl(272_90%_50%)]/5 p-4 sm:p-8 rounded-sm" data-testid="sms-go-live-checklist">
      <div className="flex flex-wrap items-center justify-between gap-3 mb-5">
        <div className="flex items-center gap-2 font-medium"><Rocket className="w-4 h-4 text-brand" /> Go-live checklist</div>
        <span className="text-sm text-muted-foreground" data-testid="go-live-progress">{done} of {steps.length} done</span>
      </div>
      <ol className="space-y-3">
        {steps.map((s, i) => (
          <li key={s.key} data-testid={`go-live-step-${s.key}`} data-done={s.done}
            className={`flex items-start gap-3 rounded-sm px-3 py-2.5 ${next?.key === s.key ? "bg-card border border-brand/40" : ""}`}>
            {s.done ? <CheckCircle2 className="w-5 h-5 text-[hsl(140_60%_40%)] shrink-0 mt-0.5" /> : <Circle className="w-5 h-5 text-muted-foreground shrink-0 mt-0.5" />}
            <div className="min-w-0">
              <div className={`text-sm ${s.done ? "text-muted-foreground" : "font-medium"}`}>{i + 1}. {s.title}</div>
              {s.hint && <div className="text-xs text-muted-foreground break-all">{s.hint}</div>}
            </div>
            {next?.key === s.key && <span className="ml-auto text-[10px] uppercase tracking-wider text-brand shrink-0">Next</span>}
          </li>
        ))}
      </ol>
      {!next && <p className="mt-4 text-sm text-[hsl(140_60%_32%)] font-medium" data-testid="go-live-complete">You're live — reminders are going out from TSTouch.</p>}
    </section>
  );
}
